module.exports = __webpack_public_path__ + "img/nu.b94ce7f2.svg";